export const hasCookie = name => {
  try {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    return parts.length === 2;
  } catch (_unused) {
    return false;
  }
};